import {Gender, Status} from "../enums/enums";

const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
const mobilePattern = /^(?:\+91[-\s]?|91[-\s]?|0)?[1-9]\d{9}$/;
const passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/;

export const userSchema = () => {
    return (
        {
            fName: {
                type: 'text',
                label: 'First name',
                columns: {sm: 12, md: 6},
            },
            lName: {
                type: 'text',
                label: 'Last name',
                columns: {sm: 12, md: 6},
            },
            phone: {
                type: 'text',
                label: 'Mobile',
                columns: {sm: 12, md: 6},
                validation: (value) => {
                    if (value.trim() === '') return 'Mobile is required';
                    if (!mobilePattern.test(value)) return "Please enter a valid Indian phone number (e.g. 9876543210, +919876543210, 01722001234)";
                    return null;
                }
            },
            email: {
                type: 'email',
                label: 'Email',
                columns: {sm: 12, md: 6},
                validation: (value) => {
                    if (value.trim() === '') return null;
                    if (!emailPattern.test(value)) return 'Invalid email';
                    return null;
                }
            },
            password: {
                type: 'password',
                label: 'Password',
                columns: {sm: 12, md: 6},
                validation: (value) => {
                    if (value.trim() === '') return 'Password is required';
                    if (!passwordPattern.test(value)) return 'Password must contain at least 8 characters, one uppercase, one lowercase, one number and one special character';
                    return null;
                }
            },
            status: {
                type: 'select',
                label: 'Status',
                enums: true,
                options: Status,
                columns: {sm: 12, md: 6},
                validation: (value) => {
                    return null;
                },
            },
            image: {
                type: 'file',
                label: 'Image',
                columns: {sm: 12, md: 6},
            },
            customer: {
                type: 'object',
                label: 'Customer',
                properties: {
                    gender: {
                        type: 'select',
                        label: 'Gender',
                        options: Gender,
                        enums: true,
                        columns: {sm: 12, md: 6},
                    },
                }
            }
        }
    )
}

